export default {
  label: {
    hot: 'Hottest',
    new: 'Newest',
    old: 'Oldest',
    influence: '+ AAA',
    interactions: '+ Interactions',
    shares: '+ Shares',
    likes: '+ Likes',
    comments: '+ Comments',
  },
};
